import { convertStringArrayToEnumLikeObject } from '@/utils/enum-helpers';

export const ERROR_MESSAGES = {
  INTERNAL_SERVER_ERROR: 'Internal server error occurred!',
  ACCESS_DENIED: 'You do not have permission to access.',
  UNEXPECTED: 'Unexpected Error',
  USER_NOT_FOUND: 'User not found!',
  ADDRESS_NOT_FOUND: 'Address not found!',
  TENANT_ADDRESS_NOT_FOUND: 'Tenant address not found!',
  CREATE_ADDRESS_ERROR: 'Create address has error!',
  UPDATE_ADDRESS_ERROR: 'Update address has error!',
  EMAIL_ALREADY_EXISTS: 'An account with the given email already exists.',
  CREATE_USER_ERROR: 'Create user has error!',
  CREATE_PROFILE_ERROR: 'Create profile has error!',
  BOOKING_SESSION_NOT_FOUND: 'The booking session not found!',
  RESCHEDULE_MIN_TIME_VIOLATION:
    'Rescheduling is only allowed for sessions more than 12 hours prior to the start time.',
  RESCHEDULE_ONCE_ONLY: 'Rescheduling is limited to one time only.',
  EMAIL_TEMPLATE_NOT_FOUND: 'Cannot find email template!',
  RESCHEDULE_BOOKING_ERROR: 'Reschedule booking has error!',
  COACH_BOOKING_NOT_FOUND: 'The coach booking not found!',
  SESSION_ALREADY_COMPLETED: 'Session has already been completed.',
  COACH_PROGRAM_NOT_FOUND:
    'This coach program is not found, please contact system administrator.',
  INVALID_TYPE: 'Invalid type',
  FEEDBACK_SESSION_EXPIRED:
    'You are no longer able to edit or add feedback as the session has expired.',
  CREATE_COACH_PROGRAM_ERROR: 'Create coach program has error',
  COACH_PROGRAM_NOT_RESUMED: 'Please ensure coach program has resumed.',
  SCHEDULE_END_BEFORE_BOOKING:
    'Please ensure you your schedule ends after your latest booking session.',
  RESUME_AFTER_HIATUS:
    'Please ensure you resume your session after your hiatus time.',
  COACH_PROFILE_DELETED:
    'This coach profile may have been deleted, please contact system administrator.',
  OUTLOOK_TEAMS_NOT_INTEGRATED:
    'Please ensure both Microsoft Outlook and Microsoft Teams are integrated.',
  FOOD_DIET_NOT_FOUND: 'Food diet not found!',
  MEALTIME_NOT_FOUND: 'Mealtime not found!',
  CATEGORY_NOT_FOUND: 'Category not found!',
  FOOD_CUISINE_NOT_FOUND: 'Food cuisine not found!',
  PREFERENCES_NAME_NOT_FOUND: 'Preferences name not found!',
  INGREDIENT_NOT_FOUND: 'Ingredient not found!',
  NUTRIENT_NOT_FOUND: 'Nutrient not found!',
  ALLERGEN_NOT_FOUND: 'Allergen not found!',
  FOOD_NOT_FOUND: 'Food not found!',
  PROFILE_NOT_FOUND: 'Profile not found!',
  KIT_NOT_FOUND: 'This kit does not exist',
  HOME_PAGE_RULE_NOT_FOUND: 'Home page rule not found!',
  UPDATE_PROFILE_ERROR: 'Update profile has error',
  CREATE_NOTE_ERROR: 'Create note has error',
  NOTE_NOT_FOUND: 'Note not found!',
  NOTIFICATION_NOT_FOUND: 'Notification not found!',
  SEQUENCING_SHORT_NAME_NOT_FOUND: 'Sequencing short name not found!',
  BATCH_NOT_FOUND: 'Batch not found!',
  BATCH_ALREADY_SENT_FOR_SEQUENCING:
    'Failed to change batch confirmation status: Batch has already been sent for sequencing',
  BATCH_NOT_CONFIRMED: 'Please ensure batch is confirmed.',
  BATCH_SIZE_INVALID:
    'Please ensure there is a min. of 3 and max. of 40 sequences in the batch.',
  BATCH_ALREADY_CONFIRMED: 'No changes can be made as batch is confirmed.',
  KIT_STATUS_INVALID_FOR_SAMPLE:
    'Please ensure kit status is activated or received at the lab.',
  CREATE_SAMPLES_ERROR: 'Create sample(s) has error',
  SAMPLE_NOT_FOUND: 'Sample not found!',
  SAMPLE_ALREADY_SEQUENCED:
    'Sample has been sequenced thus it cannot be deleted.',
  DNA_SAMPLE_NOT_FOUND: 'DNA sample not found',
  LAB_ID_REQUIRED: 'Please create a Lab ID first.',
  SEQUENCE_STATUS_REASON_REQUIRED:
    'Please provide reason to update sequence status.',
  SEQUENCE_NOT_FOUND: 'Sequence not found!',
  SEQUENCE_STATUS_SKIPPED: 'Update status failed: Please do not skip statuses.',
  FILE_EMPTY: 'Please ensure file is not empty.',
  CSV_FILE_REQUIRED: 'Please ensure to upload a csv file.',
  SEQUENCE_HISTORY_NOT_FOUND: 'Sequence history not found!',
  SEQUENCING_PARTNER_ALREADY_EXISTS:
    'A sequencing partner with the given name or abbreviation already exists.',
  SEQUENCING_PARTNER_NOT_FOUND: 'Sequencing partner not found!',
  SEQUENCING_SHORT_NAME_ALREADY_EXISTS:
    'A sequencing short name with the given name already exists.',
  SEQUENCING_SHORT_NAME_DOES_NOT_EXIST:
    "A sequencing short name with the given name doesn't exists.",
  SEQUENCING_TYPE_ALREADY_EXISTS:
    'A sequencing type with the given name already exists.',
  SEQUENCING_TYPE_NOT_FOUND: 'Sequencing type not found!',
  REPORT_NOT_PUBLISHED: 'Please ensure report is published.',
  DATE_RANGE_REQUIRED: 'Please input date range.',
  KIT_ALREADY_ACTIVATED: 'This Kit ID has been activated previously.',
  PARTICIPANT_NOT_FOUND: 'Participant not found!',
  ORDER_NOT_FOUND: 'Order not found!',
  REPORT_NOT_AVAILABLE: 'This report is not available yet.',
  EXTERNAL_PARTICIPANT_REQUIRED: 'Please input external participant.',
  KIT_NOT_ACTIVATED: 'This kit is not activated yet.',
  FIELD_REQUIRED: 'Field is required',
  KIT_ID_REQUIRED: 'Kit ID is required',
  ONE_OR_MORE_KITS_ALREADY_ACTIVATED:
    'One or more kits have been activated before.',
  ALL_KITS_ASSIGNED: 'All of the Kits in this order have been assigned',
  REPORT_NOT_FOUND: 'Report not found!',
  INVALID_STATUS: 'Status is invalid',
  KIT_UNASSIGNED: 'Your kit is unassigned',
  REPORT_NOT_READY_CHECK_LATER:
    'This report is not available yet, please check back later.',
  TIME_SLOT_UNAVAILABLE:
    'The time slot you have chosen is unavailable, please select another time.',
  INVALID_ORDER_ITEM: 'Invalid order item',
  KIT_QUANTITY_MISMATCH:
    'Please ensure the number of kits is the same as the order quantity.',
  EXISTING_ACCOUNT_PLEASE_LOGIN:
    'You have an existing account, please login to order instead.',
  EXTERNAL_PARTICIPANT_ID_MISSING:
    'Please ensure all kits have an external participant ID.',
  ORDER_ITEM_NOT_FOUND: 'The order item not found!',
  DUPLICATE_KIT_ID: 'Duplicate Kit ID',
  KIT_ID_ALREADY_EXISTS: 'This Kit ID already exists.',
  ORDER_ID_ALREADY_EXISTS: 'This Order ID already exists.',
  ORDER_IDS_NOT_ARRAY: 'The orderIds is not an array',
  INVALID_ORDER: 'The order is invalid',
  CANNOT_UPDATE_PAYMENT_STATUS: "Can't update payment status",
  CANNOT_UPDATE_ORDER_STATUS: "Can't update order status",
  SHOPIFY_ORDER_ID_FROM_MUST_BE_LESS:
    'shopifyOrderIdFrom must be less than shopifyOrderIdTo',
  SHOPIFY_ORDER_ID_RANGE_INVALID:
    'shopifyOrderIdFrom and shopifyOrderIdTo must be greater than or equal to 1001',
  PRODUCT_NOT_FOUND: 'Product not found!',
  INVALID_BUNDLE_PRODUCT: 'Invalid bundle product',
  PRODUCT_ALREADY_HAS_ORDER: 'The product has already the order',
  PROJECT_NOT_FOUND: 'Project not found!',
  CANNOT_DELETE_DEFAULT_PROJECT: 'Default project cannot be deleted.',
  PROJECT_NAME_EXISTS_IN_CHANNEL:
    'A project with the given name already exists in the channel',
  PROJECT_NAME_ALREADY_EXISTS: 'A project with the given name already exists.',
  SETTING_DATA_EMPTY: 'The setting data is empty.',
  STRIPE_ID_NOT_FOUND: 'Stripe Id is not existed',
  PURCHASE_HISTORY_NOT_FOUND: 'Purchase history not found!',
  SUBDOMAIN_OR_PARTNER_ALREADY_EXISTS:
    'A subdomain or partner with the given name already exists.',
  TENANT_NOT_FOUND: 'Tenant not found!',
  EMAILS_REQUIRED: 'Please provide email(s) of user(s).',
  NAME_ALREADY_EXISTS: 'This name already exists.',
  TOKEN_EXPIRED_OR_INVALID:
    'Token is expired or invalid, please contact the system administrator.',
  PROGRAM_NAME_ALREADY_EXISTS: 'A program with the given name already exists.',
  COACH_PROGRAM_UPDATE_FAILED: 'The coach program updated failed!',
  PARTNER_NOT_FOUND: 'Partner does not found',
  REFRESH_AND_RETRY:
    'Please refresh the page and try again. If problem persists, please email care@bioandme.asia',
  KIT_ID_EXISTS_IN_ANOTHER_ORDER: 'Kit ID exists in another order',
  KIT_ID_DOES_NOT_EXIST:
    'Kit ID does not exists. Please ensure you entered the correct kit ID',
  KIT_ID_DOES_NOT_EXIST_USER_FACING:
    'Your kit ID does not exist, please check and try again.',
  SEQUENCE_HAS_NO_ANALYSIS_ID:
    'This sequence has still not the analysis ID yet',
  KIT_ID_INCORRECT_CONTACT_PROVIDER:
    'Your Kit ID is incorrect, please contact your healthcare provider for assistance.',
  KIT_ID_NOT_EXIST_CONTACT_PROVIDER:
    'Your Kit ID does not exist, please contact your healthcare provider for assistance.',
  FTP_NAME_ALREADY_EXISTS: 'The ftp name is already existed',
  FTP_NAME_NOT_FOUND: 'The ftp name is not found',
  DONOR_SAMPLE_ALREADY_EXISTS_IN_FTP:
    'Donor sample is already existed in this ftp',
  DONOR_SAMPLE_NOT_FOUND: 'Donor sample is not found',
  FTP_PARTNER_ALREADY_HAS_KIT: 'The ftp partner has already kit',
  GENERATE_MAX_TEN_KITS: 'Generate up 10 kit',
  FTP_DONOR_SAMPLE_ALREADY_HAS_KIT: 'The ftp donor sample has already kit',
  CANCEL_MIN_TIME_VIOLATION:
    'Cancelling is only allowed for sessions more than 12 hours prior to the start time.',
  KIT_ID_CANNOT_BE_CHANGED:
    'This kit ID cannot be changed as it has been activated. Please request backend help to change it.',
  ORDER_CANNOT_BE_DELETED_KIT_IN_PARTNER_ORDER:
    'Order cannot be deleted as one or more kit IDs exists in a partner dashboard order.',
  ORDER_CANNOT_BE_DELETED_KITS_ACTIVATED:
    'Order cannot be deleted as one or more kits have been activated/received.',
  ANALYSIS_ID_DOES_NOT_EXIST:
    'Your analysis ID does not exist, please check and try again.',
  KIT_CANNOT_BE_RESTORED_DELETED_ORDER:
    'Kit cannot be restored as it belongs to a deleted order.',
  ORDER_CANNOT_BE_UPDATED_KIT_IN_PARTNER_ORDER:
    'Order cannot be updated as one or more kit IDs exists in a partner dashboard order.',
  KIT_CANNOT_BE_DELETED_ACTIVATED:
    'The kit cannot be deleted as it has been activated/received.',
  KIT_CANNOT_BE_DELETED_IN_PARTNER_ORDER:
    'The kit cannot be deleted as it exists in a partner dashboard order.',
  REPORT_NOT_READY: 'The Report is not ready',
  EXTRACTION_BATCH_NOT_FOUND: 'The extraction batch is not found',
  EXTRACTION_BATCH_NOT_EXTRACTED: 'The extraction batch has not been extracted',
  DATE_ALREADY_BOOKED:
    'Someone booked on this date, please choose another date',
  LAB_ID_ALREADY_EXISTS: 'This Lab ID already exists.',
  PROJECT_HAS_KITS: 'The project has kits so that you cannot update project',
  KIT_STATUS_INVALID: 'Kit status invalid',
  SUBDOMAIN_EXISTS_IN_ANOTHER_PROJECT:
    'A subdomain with the given name already exists in another projects.',
  RESTRICT_PREFIX_ALREADY_EXISTS: 'Restrict prefix already exist.',
  RESTRICT_PREFIX_NOT_FOUND: 'Restrict prefix is not exist',
  FREE_BOOKING_LIMIT_REACHED: 'You have run out of free booking',
  PRODUCT_NAME_EXISTS_IN_CHANNEL:
    'A product with the name already exists in the channel',
  CONFIRM_ORDER_ERROR:
    'Error when confirming order, please manually check kit ID and confirm order.',
  KIT_NOT_RECEIVED_IN_LAB: 'Kit is not received in the lab yet',
  KIT_HAS_NO_DNA_SAMPLES: 'Kit does not have dna samples',
  ANALYSIS_BATCH_NOT_FOUND: 'This analysis batch does not exist',
  ANALYSIS_BATCH_ALREADY_SENT: 'This analysis batch has been sent for analysis',
  BATCH_MIN_SAMPLES_REQUIRED: 'Each batch needs to have min. 2 samples',
  ANALYSIS_SAMPLE_NOT_FOUND: 'Analysis sample not found!',
  ORGANIZATION_NOT_FOUND: 'Organization not found!',
  ORGANIZATION_JSON_CONFIG_REQUIRED:
    'Please upload json config of organization!',
  ORGANIZATION_ALREADY_EXISTS: 'Organization already exists',
  CANNOT_CHANGE_COMPLETED_ORGANIZATION:
    'Can not change json config or subdomain for completed organization',
  RULE_NOT_FOUND: 'Rule not found.',
  FILE_RECOVERY_INVALID: 'File recovery is invalid',
  WRONG_CODE_TOO_MANY_TIMES: 'Wrong code many times',
  INVALID_CAPTCHA: 'Invalid captcha',
  INVALID_OTP_CODE: 'Invalid opt code',
  CONFLICT_REPORT_TYPE_OR_QUEUE: 'Conflict report type or 16s-ml queue',
  DADA2_CONFLICT_WITH_OTHER_REPORT_TYPE:
    'The DADA2 report type cannot be selected with another report type',
  PROJECT_NAME_NOT_IN_DB_CONFIG:
    'The project name does not exists in DB Configuration',
  GLOBAL_KEY_NOT_FOUND: 'The global key not found',
  GLOBAL_KEY_ALREADY_EXISTS: 'The global key is existed',
  RELEASE_DEV_KEY_NOT_FOUND: 'The release development key not found',
  CODE_CANNOT_BE_VERIFIED: 'The code cannot be verified at this time',
  INSUFFICIENT_PERMISSIONS: 'Insufficient permissions for this operation.',
  WRONG_EMAIL_OR_PASSWORD: 'Wrong email or password',
  DUPLICATE_SAMPLE_ID: 'Duplicate sample ID',
  STATUS_CANNOT_BE_CHANGED: 'This status cannot be changed',
  PROJECT_ALREADY_IN_USE: 'Project has been used',
  UNRECOGNIZED_SERVICE: 'Unrecognized service',
  INVALID_STACK_TYPE: 'Invalid stack type',
  INVALID_SEMANTIC: 'Invalid semantic',
  INVALID_ORGANIZATION_TYPE: 'Invalid organization type',
  ALERT_NOT_FOUND: 'Alert not found!',
  ALERT_TYPE_NOT_FOUND: 'Alert type not found!',
  NOT_ALLOWED_TO_UPDATE_ALERT: 'You are not allowed to update this alert',
  PASSWORD_EXPIRED: 'Password expired',
  PASSWORD_PREVIOUSLY_USED: 'Password has previously been used',
  ATTEMPT_LIMIT_EXCEEDED: 'Attempt limit exceeded, please try after some time.',
  CANNOT_CHANGE_COMPLETED_OR_CANCELLED_ORDER:
    'Cannot change order status which is completed or cancelled',
  CANNOT_SYNC_ANALYSIS_BATCH_NO_TEMP_FOLDER:
    'Can not sync analysis batch because of no temp folder of samples',
  ANALYSIS_BATCH_SYNC_IN_PROGRESS: 'This analysis batch is in progress of sync',
  SAMPLE_IN_SYNC_JOB: 'This sample is in sync job',
  SAMPLE_SYNC_IN_PROGRESS: 'This sample is in progress of sync',
  PRODUCTS_OUT_OF_STOCK:
    'The following products are out of stock or not available in sufficient quantity for this order!',
  ORDER_CANNOT_BE_RESTORED_DELETED_PRODUCT:
    'Order cannot be restored as it belongs to a deleted product.',
  INVALID_PDF_TEMPLATE: 'Invalid pdf template',
  SAMPLE_COUNT_MUST_BE_ONE_WHEN_SAMPLE_ID_SET:
    'No of samples must be 1 when sampleId is set',
  ORDER_CANNOT_BE_DELETED_KITS_IN_BATCH:
    'Order cannot be deleted as one or more kits have been use in batch(s).',
  INVALID_VERIFICATION_CODE:
    'Invalid verification code provided, please try again.',
  FOOD_SET_NAME_LANGUAGE_MISMATCH:
    'The value of the food set name is not compatible with the value of the PDF template language',
  INVALID_FOOD_LANGUAGE:
    'Invalid food language. Corresponding settings do not support this language.',
  SAMPLES_FAILED_FASTQC: 'Samples did not pass FASTQC',
  SAMPLES_UNDERGOING_FASTQC: 'Samples are undergoing FASTQC',
  SAMPLES_ALREADY_SENT_FOR_ANALYSIS: 'Samples are already sent for analysis',
  SAMPLE_TYPE_NOT_SUPPORTED_IN_CONFIG:
    'Sample type is not supported in config of associated organization or project config of kit.',
  ROLE_ALREADY_ASSIGNED: 'This role has been assigned to the user.',
  ROLE_NOT_FOUND: 'This role does not exist.',
  INVALID_PARAMS: 'Invalid params',
  CANNOT_DELETE_CONFIRMED_ORGANIZATION: 'Cannot delete confirmed organization',
  CROSS_ORIGIN_ACCESS_DENIED:
    'Access denied due to cross-origin request policy',
  INVALID_FILE_TYPE: 'Invalid file type',
  PRE_OR_POST_GHT_KIT_NOT_FOUND: 'preGhtKit or postGhtKit not found',
  FMT_DONOR_NOT_FOUND: 'Fmt donor not found',
  FMT_CYCLE_SCREENING_TEST_NOT_FOUND: 'Fmt cycle screening test not found',
  FMT_CYCLE_NOT_FOUND: 'Fmt cycle not found',
  FMT_RECIPIENT_NOT_FOUND: 'Fmt recipient not found',
  PRE_OR_POST_GHT_KIT_BELONGS_TO_ANOTHER_RECIPIENT:
    'preGhtKit or postGhtKit is belong to another Fmt recipient',
  FMT_SCREENING_TEST_TYPES_ALREADY_EXIST:
    'Some of type of Fmt cycle screening test already exists',
  FMT_RECIPIENT_PROFILE_ID_ALREADY_EXISTS:
    'Fmt Recipient ProfileId already exists',
  FMT_DONOR_PROFILE_ALREADY_EXISTS: 'Fmt Donor ProfileId already exists',
  FMT_CYCLE_ID_ALREADY_EXISTS: 'Fmt Cycle cycleId already exists',
  FMT_PAYLOAD_MISSING_CYCLE_ID_OR_TYPE:
    'Payload needs to contain both cycleId and type',
  SEQUENCE_NOT_SEQUENCING: 'Sequence is not sequencing',
  FMT_BOTTLE_NOT_FOUND: 'Fmt bottle not found',
  FMT_PRODUCT_NUMBER_ALREADY_EXISTS: 'Fmt product number already exists',
  FMT_BOTTLE_COUNT_EXCEEDS_ALIQUOTS:
    'The number of Fmt bottles exceeds the number of aliquots allowed for this Fmt product',
  FMT_BOTTLE_VOLUME_INVALID:
    'Bottle volume on payload is not valid for this Fmt product',
  PRODUCT_TYPE_NOT_FMT: 'Product type is not FMT',
  FMT_PRODUCT_NOT_FOUND: 'Fmt product not found',
  CREATE_ORDER_ITEM_FOR_PLACEHOLDER_FMT_FAILED:
    'Failed to create OrderItem for placeholder FMT Product flow.',
  CREATE_PLACEHOLDER_ORDER_FOR_FMT_FAILED:
    'Failed to create Placeholder Order for FMT Product flow.',
  CREATE_FMT_BOTTLE_LOGS_FAILED: 'Failed to create Fmt bottle log(s)',
  CREATE_FMT_BOTTLE_STATUS_LOGS_FAILED:
    'Failed to create Fmt bottle status log(s)',
  CREATE_KIT_FOR_FMT_FAILED: 'Failed to create Kit for FMT Product flow.',
  GET_TOTAL_LIVE_STOCK_FAILED: 'Failed to get total live stock',
  ONE_OR_MORE_BOTTLE_IDS_NOT_FOUND:
    'One or more bottleIds provided do not exist',
  ONE_OR_MORE_BOTTLE_IDS_BELONG_TO_ANOTHER_ORDER:
    'One or more bottleIds provided belong to another order',
  CREATE_ORDER_ITEM_FOR_FMT_FAILED:
    'Failed to create OrderItem for FMT Product flow.',
  UPDATE_FMT_BOTTLE_STATUS_FAILED:
    'Failed to update Fmt bottle status for FMT Product flow.',
  ONE_OR_MORE_BOTTLE_IDS_BELONG_TO_ANOTHER_PRODUCT:
    'One or more bottleIds provided belong to another product',
  ONE_OR_MORE_BOTTLES_NOT_READY_FOR_SALE:
    'One or more bottles provided not ready for sale',
  ONE_OR_MORE_BOTTLES_CANNOT_CHANGE_STATUS:
    'One or more bottles provided can not change status',
  FMT_PRODUCT_REQUIRES_DOCTOR_REVIEW_PASS:
    'Cannot create Fmt product because Fmt cycle doctor review status is not pass',
  CANNOT_MODIFY_FMT_CYCLE_WITH_LINKED_PRODUCTS:
    'Cannot delete or update Fmt cycle status because Fmt products are linked to cycle(s)',
  CANNOT_DELETE_FMT_CYCLE: 'Cannot delete Fmt cycle(s)',
  CANNOT_DELETE_FMT_CYCLE_SCREENING_TEST_FAILED:
    'Cannot delete Fmt cycle(s) because of one or more Fmt screening test(s) have data',
  FMT_BOTTLE_BELONGS_TO_ANOTHER_RECIPIENT:
    'Fmt bottle is belong to another recipient',
  INVALID_BASE_PDF_SETTINGS_PAYLOAD: 'Invalid base Pdf settings payload',
  INVALID_SEQUENCE_PIPELINE_SETTING: 'Invalid pipeline setting',
  UPDATE_SEQUENCING_BATCH_FAILED: 'Failed to update sequencing batch',
  UPDATE_ANALYSIS_BATCH_FAILED: 'Failed to update analysis batch',
  INVALID_FILE_CONTENT:
    'Invalid file content detected. Please check the file content and try again using the correct format content.',
  S3_BUCKET_NOT_FOUND: 'Provided S3 bucket does not exist.',
  S3_PATH_NOT_FOUND: 'Provided S3 path does not exist in provided S3 bucket.',
  SUBSCRIPTION_NOT_FOUND: 'Subscription not found',
  SUBSCRIPTION_ALREADY_EXISTS_FOR_WEBHOOK:
    'Subscription already exists for this webhook type',
  SOME_PRODUCTS_NOT_FOUND: 'Some Products not found',
  SOME_PRODUCTS_NOT_ENOUGH_QUANTITY: 'Some Products not enough quantity',
  UNSUPPORTED_FILE_FORMAT:
    'Unsupported file format. Only .tsv and .csv files can be read',
  FAILED_TO_READ_STREAM_FROM_S3: 'Failed to read stream data from S3',
  FAILED_TO_READ_DATA_FROM_S3: 'Failed to read data from S3',
  FAILED_TO_CREATE_ORDER_THIRD_PARTY_SYNC:
    'Failed to create order when thirdParty sync order.',
  FAILED_TO_READ_XLSX_FROM_S3: 'Failed to read xlxs data from S3',
  KIT_REPORT_FILE_TYPE_NOT_SUPPORTED: 'Some Kit Report File type not supported',
  CALCULATION_METHOD_NOT_SUPPORTED:
    'Some calculation methods are not supported. Currently only one of sum, subtraction, multiplication, division is supported.',
  KIT_NOT_ALLOWED_FOR_EXTRACTION: 'Some Kit is not allow DNA extraction',
  INVALID_COMMERCIAL_FASTQ_FILE_FORMAT:
    'Invalid format of commercial analysis sample FASTQ files. The format should be XXXX-XXXX-XXXX_(1|2).fq.gz. Example: TEST-TEST-TEST_1.fq.gz',
  ANALYSIS_SAMPLE_NOT_ENOUGH_FASTQ_FILES:
    'Analysis sample not enough FASTQ files',
  INVALID_COMMERCIAL_SAMPLE_ID_FORMAT:
    'Invalid format of commercial analysis sample FASTQ files. The format should be XXXX-XXXX-XXXX. Example: TEST-TEST-TEST',
  COMMERCIAL_ANALYSIS_SAMPLE_NOT_FOUND: 'Commercial analysis sample not found',
  SAMPLES_PLANNED_FOR_FASTQ_PROCESSOR:
    'Samples are in planned to start FASTQ processor',
  SAMPLES_PLANNED_FOR_FASTQ_PROCESSOR_RESTART:
    'Samples are in planned to restart FASTQ processor',
  CONFLICT_SAMPLE_TYPE_WITH_BATCH_CLIENT_TYPE:
    'Conflict samples type with analysis batch client type',
  KIT_LINKED_TO_ANOTHER_COMMERCIAL_SAMPLE:
    'Kit linked to other commercial analysis sample',
  INVALID_PAYLOAD_QUANTITY_OR_KIT_SERIALS:
    'Invalid payload: quantity need to be provided',
  THIRD_PARTY_ALREADY_EXISTS: 'Third party already exists',
  THIRD_PARTY_NOT_FOUND: 'Third party not found',
  CONFLICT_KIT_PROJECT_WITH_BATCH_PROJECT:
    "Conflict kit's project with request commercial analysis batch's project",
  PROJECT_NOT_SUPPORTED_IN_COMMERCIAL_BATCH:
    "Related project not supported in commercial analysis batch's flow",
  INVALID_PAYLOAD: 'Invalid Payload',
  INVALID_SHIPPING_INFORMATION:
    'Invalid Shipping Information, these fields are required: First Name, Last Name, Address, Phone Number',
  PROJECT_NOT_SUPPORTED_IN_RESEARCH_BATCH:
    "Project not supported in research analysis batch's flow",
  INCONSISTENT_PROJECT_PIPELINE_SETTINGS:
    'Inconsistent project pipeline settings detected across selected kits',
  SEQUENCES_MUST_BELONG_TO_SAME_BATCH:
    'All sequences must belong to the same batch',
  USER_NOT_ALLOWED_AS_PIC:
    'User not allowed to assign to be PIC of the project',
  CUSTOMER_ALREADY_EXISTS: 'Customer already exists',
  EMAIL_ASSOCIATED_WITH_ANOTHER_CUSTOMER:
    'Customer with this email already exists',
  CUSTOMER_NOT_FOUND: 'Customer not found',
  INVALID_PAYLOAD_CUSTOMER_ID_OR_ID:
    'Invalid payload: customerId or id need to be provided',
  PROMO_CODE_ALREADY_EXISTS: 'Promo code already exists',
  ORDER_TOTAL_BELOW_MINIMUM_FOR_PROMO:
    'Order total does not meet the minimum purchase amount required for this promo code',
  ONE_OR_MORE_PROMO_CODES_NOT_FOUND: 'One or more promo codes not found',
  PROMO_CODE_MAX_USAGE_REACHED:
    'One or more promo codes have reached their maximum usage limit',
  PROMO_CODE_EXPIRED: 'One or more promo codes are expired',
  PROMO_CODE_ALREADY_APPLIED: 'One or more promo codes already applied',
  CREATE_ORDER_STATUS_FAILED: 'Fail to create one or more order status',
  ONE_OR_MORE_KITS_NOT_FOUND: 'One or more kits not found',
  DELETE_PROMO_CODE_FAILED:
    'Failed to delete or update promo code. This promo code is used in one or more orders.',
  ORDER_CAN_ONLY_CANCEL_FROM_CREATED:
    'Order status is only allowed to be cancelled if current status is CREATED',
  KIT_ALREADY_ADDED_TO_EXTRACTION_BATCH:
    'This kit has been added to extraction batch',
  EXTRACTION_BATCH_NEEDS_AT_LEAST_ONE_SEQUENCE:
    'Extraction batch must have at least 1 extraction sequence',
  EXTRACTION_BATCH_ALREADY_EXTRACTED: 'Extraction batch is already extracted',
  EXTRACTION_SEQUENCE_NOT_FOUND: 'Extraction sequence not existed',
  KIT_NOT_ALLOWED_FOR_DNA_EXTRACTION: 'Kit not allow to dna extraction',
  REVERT_INVOICE_FAILED: 'Reverting Invoice failed',
  GENERATE_DELIVERY_ORDER_FAILED: 'Fail to generate DO',
  INVOICE_NOT_FOUND: 'Invoice not found',
  ORDER_CANNOT_BE_CANCELLED:
    'Order cannot be cancelled, please contact support for more information',
  CONCENTRATION_DATA_INVALID: 'Concentration data is invalid',
  DUPLICATE_ORIGIN_ORDER_ID: 'Duplicate origin order ID',
  INVALID_SKU: 'Invalid SKU',
  INVALID_CHANNEL: 'Invalid Channel',
  INVALID_THIRD_PARTY: 'Invalid Third Party',
  PRODUCT_IDS_REQUIRED: 'Product IDs is required',
  PAYMENT_METHOD_NOT_FOUND: 'Payment method not found',
  PAYMENT_TYPE_NOT_SUPPORTED: 'System does not support this payment type',
  PAYMENT_METHOD_NOT_ASSIGNED_TO_USER:
    'Payment method not assigned to this user',
  STRIPE_SYSTEM_ERROR: 'Stripe system has error', // Do not use this error code, this error use for Stripe Error
  PAYMENT_TRANSACTION_NOT_FOUND: 'Payment transaction not found',
  ORDER_ALREADY_PAID: 'Order is already paid',
  ORDER_PAYMENT_CANNOT_RETRY_CHECKOUT:
    "Order's payment can not retry to checkout",
  PAYMENT_TRANSACTION_ALREADY_FINALIZED:
    'Payment transaction already finalized',
  ORDER_HAS_PENDING_TRANSACTION:
    'Order has transaction can be continue processing. Please contact support.',
  PAYMENT_TRANSACTION_NOT_ASSIGNED_TO_ORDER:
    'Payment transaction not assigned to any order',
  ORDER_ALREADY_REFUNDED: 'The order is already refunded',
  ORDER_HAS_REMAINING_BALANCE:
    'The order has a remaining balance that was not completed in the prior payment.',
  ORDER_DISPLAY_ID_ALREADY_IN_USE: 'The order display ID is already in use',
  ORDER_CREATION_UNEXPECTED_EXCEPTION:
    'Order cannot be created due to an unexpected exception',
  INVOICE_ALREADY_ASSIGNED_TO_ANOTHER_ORDER:
    'The invoice is already assigned to another order',
  TOO_MANY_REQUESTS: 'Too many requests',
  BAD_REQUEST: 'Bad Request',
} as const;

export type ErrorShortSyntax = keyof typeof ERROR_MESSAGES;

export const SHORTENED_ERROR_MESSAGES = convertStringArrayToEnumLikeObject(
  Object.keys(ERROR_MESSAGES) as ErrorShortSyntax[],
);
